import AnimationClip from '../AnimationClip';
import RewardLivesEffect from '../../../Prototype/Effect/RewardLivesEffect';
import TransformComponent from '../../../Component/Transform';
import { delay } from '../../../Utility/Task/TaskQueue';
import { PlayAnimation, GetAnimationClip } from '../AnimationHelper';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import Game from '../../../Game';
import RewardTextEffect from '../../../Prototype/Effect/RewardTextEffect';
import GameObject from '../../../GameObject/GameObject';
import { DragonbonesAnimationEvent } from '../../../Component/Dragonbones';
import UITextComponent from '../../../Component/UI/Text';
import { StartAudio } from '../../Audio/AudioHelper';
import { AUDIO_UI_HEARTS } from '../../Audio';
import { AudioTrackType } from '../../Audio/AudioClip';
import Scene from '../../../Scene/Scene';

interface IRewardLivesData {
    lives: 1 | 2 | 3 | 7;
    previousLives: number;
    scene: Scene;
}

export class RewardLives extends AnimationClip {
    public *execute(
        animator: GameObject,
        meta: IRewardLivesData
    ): IterableIterator<number> {
        animator.scene.emit(RenderSystemEvent.BRING_TO_FRONT, animator);

        // prettier-ignore
        const text: GameObject = GameObject.findByName('world_hud_lives_value')[0];
        text.getComponent(UITextComponent).text = meta.previousLives.toString();

        // prettier-ignore
        const livesPanel: GameObject = GameObject.findByName('world_hud_lives_panel')[0];
        const rewardEffect: GameObject = GameObject.Instantiate(
            RewardLivesEffect,
            {
                lives: [1, 2, 3, 7].find((v, i) => v >= meta.lives || i === 3),
            }
        );
        livesPanel.addChild(rewardEffect);
        animator.addChild(rewardEffect);

        const rewardTransform: TransformComponent = rewardEffect.getComponent(
            TransformComponent
        );
        rewardTransform.x += 460;
        rewardTransform.y += 353;

        const localeText = Game.locale.getText('WheelAddLives');
        animator.addChild(
            GameObject.Instantiate(RewardTextEffect, {
                text: localeText.replace('[x]', meta.lives.toString()),
                position: rewardTransform.position.clone(),
            })
        );

        let isPlaying: boolean = true;
        rewardEffect.on(DragonbonesAnimationEvent.COMPLETE, () => {
            rewardEffect.destroy();
            isPlaying = false;
        });

        yield* delay(900);

        StartAudio(meta.scene, AUDIO_UI_HEARTS, AudioTrackType.SFX);

        yield* PlayAnimation(
            GetAnimationClip('Counter', text, {
                startValue: meta.previousLives,
                finalValue: meta.previousLives + meta.lives,
            })
        );

        while (isPlaying) yield;
    }
}
